export default __webpack_public_path__ + "static/media/wave-icon.70c2a2cf.png";